import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { BarChart3, Phone, LogOut } from 'lucide-react';
import { Toaster } from '@/components/ui/sonner';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_agent-stats-1/artifacts/nm3zn43g_image.png";

function Layout({ onLogout }) {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="layout-container">
      <nav className="bg-white border-b border-slate-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center space-x-8">
              <div className="flex items-center gap-3">
                <img 
                  src={LOGO_URL} 
                  alt="Synapse1 Logo" 
                  className="h-10 w-auto"
                  data-testid="logo"
                />
              </div>
              <div className="flex space-x-4">
                <Link to="/">
                  <Button
                    variant={isActive('/') ? 'default' : 'ghost'}
                    className="flex items-center gap-2"
                    data-testid="nav-dashboard"
                  >
                    <BarChart3 className="h-4 w-4" />
                    Dashboard
                  </Button>
                </Link>
                <Link to="/executions">
                  <Button
                    variant={isActive('/executions') ? 'default' : 'ghost'}
                    className="flex items-center gap-2"
                    data-testid="nav-executions"
                  >
                    <Phone className="h-4 w-4" />
                    Executions
                  </Button>
                </Link>
              </div>
            </div>
            <div className="flex items-center">
              <Button variant="ghost" onClick={onLogout} className="flex items-center gap-2" data-testid="logout-button">
                <LogOut className="h-4 w-4" />
                Logout
              </Button>
            </div>
          </div>
        </div>
      </nav>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
      <Toaster position="top-right" />
    </div>
  );
}

export default Layout;
